import { createSelector } from "@reduxjs/toolkit";
import { PERMISSION } from "../../lib/permissions";

const EMPTY_PERMISSIONS = Object.freeze([]);

export const selectAuthState = (state) => state.auth;

export const selectProfile = createSelector(
  selectAuthState,
  (auth) => auth.profile,
);

export const selectToken = createSelector(
  selectAuthState,
  (auth) => auth.token,
);

export const selectIsAuthenticated = createSelector(
  selectToken,
  (token) => Boolean(token),
);

export const selectIsSuperAdmin = createSelector(
  selectProfile,
  (profile) => profile?.is_super_admin === true,
);

export const selectCurrentUserId = createSelector(selectProfile, (profile) => {
  const id = profile?.id;
  return typeof id === "number" ? id : id != null ? Number(id) : null;
});

export const selectPermissions = createSelector(
  selectAuthState,
  (auth) => auth.permissions || EMPTY_PERMISSIONS,
);

export const selectPermissionLookup = createSelector(
  selectPermissions,
  (permissions) => {
    const map = new Map();
    permissions.forEach((p) => {
      map.set(Number(p.menu_id), new Set(p.permission_level));
    });
    return map;
  },
);

export const makeSelectHasAction = () =>
  createSelector(
    [selectIsSuperAdmin, selectPermissionLookup, (_, args) => args],
    (isSuperAdmin, lookup, { menuId, action = PERMISSION.VIEW }) => {
      if (isSuperAdmin) return true;
      const set = lookup.get(Number(menuId));
      return set ? set.has(action) : false;
    },
  );

/** Where the server's answer about this session stands — see auth/slice.js. */
export const selectSessionStatus = createSelector(
  selectAuthState,
  (auth) => auth.sessionStatus || "idle",
);
